import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const messages = {
  api: {
    unit: {
      ft: 'ft',
      ft_hr: 'ft/hr',
      ft_s: 'ft/s',
      ft_2: 'ft^2',
      bbl: 'bbl',
      f: '°F',
      psi: 'psi',
      pct: '%',
      bbl_D: 'bbl/D',
      cc_30min: 'cc/30 min',
      cp: 'cp',
      degree_100feet: 'degree/100ft',
      ft_lt: 'ft-lbf',
      gal_stroke: 'gal/stroke',
      kip: 'kip',
      lbm_bbl: 'lbm/bbl',
      psi_ft: 'psi/ft',
      s_qt: 's/qt',
      ton_ml: 'ton-ml',
      cc: 'cc',
      ft_lbf: 'ft-lbf',
      nozzle: '-',
      rigfuel: 'bbl',
    },
  },
  apimix: {
    unit: {
      ft: 'm',
      ft_hr: 'm/hr',
      ft_s: 'm/s',
      ft_2: 'm^2',
      bbl: 'm^3',
      f: '°K',
      psi: 'bar',
      pct: '%',
      bbl_D: 'm^3/D',
      cc_30min: 'cc/30 min',
      cp: 'cp',
      degree_100feet: 'degree/100m',
      ft_lt: 'm-lbf',
      gal_stroke: 'gal/stroke',
      kip: 'kip',
      lbm_bbl: '',
      psi_ft: 'bar/m',
      s_qt: 's/qt',
      ton_ml: 'ton-ml',
      cc: 'cc',
      ft_lbf: 'm-lbf',
      nozzle: '-',
      rigfuel: 'm^3',
    },
  },
  gde: {
    unit: {
      ft: 'm',
      ft_hr: 'm/hr',
      ft_s: 'm/s',
      ft_2: 'm^2',
      pct: 'mg/l',
      bbl: 'bbl',
      bbl_D: 'bbl/D',
      cc_30min: 'mL/30min',
      cp: 'cP / lbf/100ft^2',
      degree_100feet: 'deg/30m',
      ft_lt: 'klbs-ft',
      gal_stroke: 'bbl/stroke',
      kip: 'klbs',
      lbm_bbl: 'lb/bbl',
      psi: 'psi',
      psi_ft: 'psi/ft',
      s_qt: 'sec',
      ton_ml: '-',
      f: '°C',
      cc: 'mL',
      ft_lbf: 'klbs-ft',
      nozzle: '/32in',
      rigfuel: 'liter',
    },
  },
}

export default new VueI18n({
  locale: 'api',
  messages,
})
